var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCallClock = function SvgCallClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M8.614 8.657 6.856 6.899a2.486 2.486 0 0 0-3.515 0l-.881.881a4.97 4.97 0 0 0-.733 6.104c1.463 2.4 3.764 5.712 6.887 8.835 3.125 3.125 6.438 5.426 8.838 6.888a4.965 4.965 0 0 0 6.101-.733l.881-.881c.971-.971.971-2.545 0-3.516l-1.758-1.758c-1.234-1.234-2.426-.796-3.392-.05-.945.73-2.227.799-3.165.061a45 45 0 0 1-3.99-3.526 45 45 0 0 1-3.536-4.002c-.73-.93-.676-2.203.044-3.142.752-.981 1.196-2.184-.023-3.403M9.905 3.916a12.38 12.38 0 0 1 8-2.916c6.864 0 12.429 5.565 12.429 12.43a12.38 12.38 0 0 1-2.917 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M17.904 8.458v4.972l2.486 2.485"
  })));
};
export default SvgCallClock;